import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useClient } from 'hooks/useClient';

type EmailPreviewParams = {
  subject: string;
  greeting: string;
  content: string;
};

/**
 * The broadcast as the server will send it, rendered by the real MassEmail
 * template. Only mounted while the Preview tab is open, so typing in the editor
 * costs nothing. Previous HTML stays up while a greeting edit re-renders it.
 */
export const useEmailPreview = ({ subject, greeting, content }: EmailPreviewParams) => {
  const client = useClient();

  const { data, isFetching, isError } = useQuery<{ html: string }>({
    queryKey: ['EMAIL_PREVIEW', subject, greeting, content],
    queryFn: () => client.post<{ html: string }>('/emails/preview', { subject, greeting, content }),
    placeholderData: keepPreviousData,
    staleTime: Infinity,
  });

  return { html: data?.html ?? '', isFetching, isError };
};
